import {
  Injectable,
} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RedirectCommand,
  Router,
} from '@angular/router';
import {
  JourneyModel,
  JourneysStore,
  selectSelectedJourney,
} from '@des/store/journeys';
import {
  select,
  Store,
} from '@ngrx/store';
import {
  isParamInRoute,
} from '@refx/shared-common';
import {
  Observable,
} from 'rxjs';
import {
  filter,
  map,
  take,
} from 'rxjs/operators';
import {
  SsciRouteParams,
  SsciRoutes,
} from '../../configuration/routes';

@Injectable()
export class AddFlightIdParamGuard implements CanActivate {
  constructor(private readonly router: Router, private readonly store: Store<JourneysStore>) {}

  /**
   * Add flightId as query param in the URL if not present
   *
   * @param route the active route snapshot
   */
  public canActivate(route: ActivatedRouteSnapshot): boolean | Observable<RedirectCommand> {
    return (
      isParamInRoute(SsciRouteParams.flightId, route)
      || this.store.pipe(
        select(selectSelectedJourney),
        filter((journey: JourneyModel) => !!journey),
        take(1),
        map((journey: JourneyModel) => {
          // If there is no flight id in the URL, add the first flight id available for this journey
          if (journey.flights && journey.flights.length > 0) {
            // adding the leg details here in the router
            const urlTree = this.router.createUrlTree([...route.url.map((segment) => segment.path), journey.flights[0].id, 0]);
            // Passing state from previous navigation as well
            return new RedirectCommand(urlTree, {
              replaceUrl: false,
              state: this.router.getCurrentNavigation()?.extras.state
            });
          }

          return new RedirectCommand(this.router.parseUrl(SsciRoutes.overview), {
            replaceUrl: false
          });
        })
      )
    );
  }
}
